import React from 'react'
import _ from 'lodash'
import qs from 'query-string'
import axios from 'axios'
import Form from 'react-bootstrap/Form'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import { Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'

import logo from 'assets/logo-iso-white.svg'
import './PasswordRecovery.css'

class PasswordRecovery extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isTokenValid: null,
            showPwdError: false,
        }
    }

    async componentDidMount() {
        try {
            //Get token from the query param and validate it
            let search = _.get(this.props, 'location.search')
            if (_.isString(search)) {
                let token = qs.parse(search).token

                let url = `/api/v1/auth/password-reset?token=${token}`
                let resp = await axios.get(url)
                let email = _.get(resp, 'data.email')
                if (!email) {
                    //TODO unable to validate token
                    return
                }

                this.setState({ isTokenValid: true, token: token, email: email })
            } else {
                this.setState({ isTokenValid: false })
            }
        } catch (err) {
            this.setState({ isTokenValid: false })
        }
    }

    onSubmitForgotPwd = async e => {
        e.preventDefault() //Prevent form from submitting

        //Validate password values
        let pass = _.get(this, 'passwordVal.value')
        let confirmPass = _.get(this, 'confirmPasswordVal.value')
        if (!pass || pass === '' || pass.length > 60) {
            this.setState({
                showPwdError: true,
                pwdError: 'is-invalid',
                confirmPwdError: 'is-invalid',
                pwdErrMsg: 'Password is required',
            })
            return
        } else if (pass !== confirmPass) {
            this.setState({
                showPwdError: true,
                pwdError: 'is-invalid',
                confirmPwdError: 'is-invalid',
                pwdErrMsg: 'Passwords do not match',
            })
            return
        } else if (!this.state.token) {
            this.setState({
                showPwdError: true,
                pwdError: '',
                confirmPwdError: '',
                pwdErrMsg:
                    'We ran into an issue resetting your password. Please try clicking the link in your password recovery email again. If the problem persists, try resetting your password again.',
            })
            return
        }

        //Send password reset request
        try {
            let body = {
                email: this.state.email,
                password: pass,
                token: this.state.token,
            }
            await axios.post('/api/v1/auth/password', body)
            this.props.history.push('/')
        } catch (err) {
            let status = _.get(err, 'response.data.statusCode')
            if (status >= 400 && status <= 499) {
                let errorField = _.get(err, 'response.data.errors[0]')
                if (errorField) {
                    let msg = errorField[Object.keys(errorField)[0]] //Get the value of the first property in this obj
                    this.setState({
                        showPwdError: true,
                        pwdError: errorField.email ? 'is-invalid' : null,
                        confirmPwdError: errorField.email ? 'is-invalid' : null,
                        pwdErrMsg:
                            msg || 'Error encountered, please try again. If the problem persists please contact us.',
                    })
                }
            } else {
                this.setState({
                    showPwdError: true,
                    pwdError: 'is-invalid',
                    confirmPwdError: 'is-invalid',
                    pwdErrMsg: 'Error encountered, please try again. If the problem persists please contact us.',
                })
            }
        }
    }

    renderContent = () => {
        if (this.state.isTokenValid === null) {
            return (
                <>
                    <h1>Validating...</h1>
                </>
            )
        } else if (this.state.isTokenValid === false) {
            return (
                <>
                    <Container className="pwd-recovery-container text-center">
                        <a href={process.env.REACT_APP_COMPANY_WEBSITE_URL}>
                            <img src={logo} id="logo" alt={''} />
                        </a>

                        <div className={'new-pwd'}>
                            <h3>Uh oh...</h3>
                            <p className="body-1">
                                Looks like your password recovery link is invalid or has expired. Remember, the password
                                recovery link is only valid for 24 hours. Please try resetting your password again.
                            </p>
                            <Link to={'/'} className="meta-3 text-pink">
                                Take me home
                            </Link>
                        </div>
                    </Container>
                </>
            )
        } else {
            return (
                <>
                    <Container className="pwd-recovery-container text-center">
                        <a href={process.env.REACT_APP_COMPANY_WEBSITE_URL}>
                            <img src={logo} id="logo" alt={''} />
                        </a>

                        <div className={'new-pwd'}>
                            <h3>Create a new password</h3>

                            <Form id="new-pwd-form" onSubmit={e => this.onSubmitForgotPwd(e)}>
                                <Alert
                                    show={this.state.showPwdError}
                                    onClose={() => {
                                        this.setState({ showPwdError: false })
                                    }}
                                    dismissible
                                    variant="danger"
                                >
                                    <span className="body-3 text-pink">
                                        {_.isString(this.state.pwdErrMsg)
                                            ? this.state.pwdErrMsg
                                            : 'Error occurred. Please try again'}
                                    </span>
                                </Alert>

                                <Form.Group controlId="password">
                                    <Form.Control
                                        type="password"
                                        placeholder="Password"
                                        ref={node => (this.passwordVal = node)}
                                        className={this.state.pwdError}
                                    />
                                </Form.Group>

                                <Form.Group controlId="confirmPassword">
                                    <Form.Control
                                        type="password"
                                        placeholder="Confirm password"
                                        ref={node => (this.confirmPasswordVal = node)}
                                        className={this.state.confirmPwdError}
                                    />
                                </Form.Group>

                                <Button variant="secondary" type="submit" className="btn-block">
                                    Submit
                                </Button>
                            </Form>
                        </div>
                    </Container>
                </>
            )
        }
    }

    render() {
        return <div className="pwd-recovery text-center">{this.renderContent()}</div>
    }
}

export default PasswordRecovery
